import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { TrackingService } from '../tracking.service';
import * as trackingActions from './tracking.actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { Tracking } from '../../_models/tracking';
import { User } from '../../_models/user';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import * as rootActions from '../../state/app.actions';
import * as fromRoot from '../../state/app.reducer';

@Injectable()
export class TrackingEffects {

    @Effect()
    loadTracking$ = this.actions$.pipe(
        ofType(trackingActions.TrackingActitonTypes.LoadTrackings),
        mergeMap((action: trackingActions.LoadTrackings) => {
                this.changingLoading(true);
                // console.log('-->... Payload LoadTrackings =');
                // console.log(action.payload);

                return this.trackingService.getTrackings(action.payload).pipe(
                    map((trackings: Tracking[]) => {
                        this.changingLoading(false);
                        return new trackingActions.LoadTrackingsSuccess(trackings);
                    }),
                    catchError(err => of(new trackingActions.LoadTrackingsFail(err)))
                )
            }
        )
    );

    // NOTA: Lanzar directamente otra acción sin llamar a ningún servicio.
    // @Effect()
    // loadTrackingSuccess$ = this.actions$.pipe(
    //     ofType(trackingActions.TrackingActitonTypes.LoadTrackingsSuccess),
    //     map((action: rootActions.ChangeLoading) => (new rootActions.ChangeLoading(false)))
    // );

    // NOTA: sin usar Loading ni ventanas de información.
    // @Effect()
    // updateTracking$: Observable<Action> = this.actions$.pipe(
    //     ofType(trackingActions.TrackingActitonTypes.UpdateTracking),
    //     map((action: trackingActions.UpdateTracking) => action.payload),
    //     mergeMap(( tracking: Tracking) =>
    //         this.trackingService.updateTracking(tracking).pipe(
    //         map(updatedTracking => (new trackingActions.UpdateTrackingSuccess(updatedTracking))),
    //         catchError(err => of(new trackingActions.UpdateTrackingFail(err)))
    //     ))
    // );

    @Effect()
    updateTracking$ = this.actions$.pipe(
        ofType(trackingActions.TrackingActitonTypes.UpdateTracking),
        mergeMap((action: trackingActions.UpdateTracking) => {
                this.changingLoading(true);
                // console.log('-->... Payload UpdateTracking =');
                // console.log(action.payload);

                return this.trackingService.updateTracking(action.payload).pipe(
                    map((tracking: Tracking) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server UpdateTracking =');
                        console.log(tracking);
                        if (tracking !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/tracking', null, 'info');
                            return new trackingActions.UpdateTrackingSuccess(tracking);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new trackingActions.UpdateTrackingFail('ERROR UpdateTracking effect.');
                        }
                    }),
                    catchError(err => of(new trackingActions.UpdateTrackingFail(err)))
                )
            }
        )
    );


    // @Effect()
    // createTracking$: Observable<Action> = this.actions$.pipe(
    //     ofType(trackingActions.TrackingActitonTypes.CreateTracking),
    //     map((action: trackingActions.CreateTracking) => action.payload),
    //     mergeMap(( tracking: Tracking) =>
    //         this.trackingService.createTracking(tracking).pipe(
    //         map(createTracking => (new trackingActions.CreateTrackingSuccess(createTracking))),
    //         catchError(err => of(new trackingActions.CreateTrackingFail(err)))
    //     ))
    // );

    @Effect()
    CreateTracking$ = this.actions$.pipe(
        ofType(trackingActions.TrackingActitonTypes.CreateTracking),
        mergeMap((action: trackingActions.CreateTracking) => {
                this.changingLoading(true);
                // console.log('-->... Payload CreateTracking =');
                // console.log(action.payload);

                return this.trackingService.createTracking(action.payload).pipe(
                    map((tracking: Tracking) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server CreateTracking =');
                        // console.log(tracking);
                        if (tracking !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/tracking', null, 'info');
                            return new trackingActions.CreateTrackingSuccess(tracking);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new trackingActions.CreateTrackingFail('ERROR CreateTracking effect.');
                        }
                    }),
                    catchError(err => of(new trackingActions.CreateTrackingFail(err)))
                )
            }
        )
    );

    // @Effect()
    // deleteTracking$: Observable<Action> = this.actions$.pipe(
    //     ofType(trackingActions.TrackingActitonTypes.DeleteTracking),
    //     map((action: trackingActions.DeleteTracking) => action.payload),
    //     mergeMap(( tracking: Tracking) =>
    //         this.trackingService.deleteTracking(tracking).pipe(
    //         map(deleteTrackingId => (new trackingActions.DeleteTrackingSuccess(deleteTrackingId))),
    //         catchError(err => of(new trackingActions.DeleteTrackingFail(err)))
    //     ))
    // );

    @Effect()
    deleteTracking$ = this.actions$.pipe(
        ofType(trackingActions.TrackingActitonTypes.DeleteTracking),
        mergeMap((action: trackingActions.DeleteTracking) => {
                this.changingLoading(true);
                // console.log('-->... Payload DeleteTracking =');
                // console.log(action.payload);

                return this.trackingService.deleteTracking(action.payload).pipe(
                    map((trackingId: bigint) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server DeleteTracking =');
                        console.log(trackingId);
                        if (trackingId !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');
                            return new trackingActions.DeleteTrackingSuccess(trackingId);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new trackingActions.DeleteTrackingFail('ERROR DeleteTracking effect.');
                        }
                    }),
                    catchError(err => of(new trackingActions.DeleteTrackingFail(err)))
                )
            }
        )
    );


    @Effect()
    loadUsers$ = this.actions$.pipe(
        ofType(trackingActions.TrackingActitonTypes.LoadUsers),
        mergeMap((action: trackingActions.LoadUsers) => {
                this.changingLoading(true);
                // console.log('-->... Payload LoadUsers =');
                // console.log(action.payload);

                return this.trackingService.getUsers().pipe(
                    map((users: User[]) => {
                        this.changingLoading(false);
                        return new trackingActions.LoadUsersSuccess(users);
                    }),
                    catchError(err => of(new trackingActions.LoadUsersFail(err)))
                )
            }
        )
    );

    // -----------------------------

    constructor(private actions$: Actions,
                private trackingService: TrackingService,
                private storeRoot: Store<fromRoot.State>) {

    }

    changingLoading(value: boolean) {
        console.log('---->>>>.... Ejecutando changingLoading: ' + value);
        this.storeRoot.dispatch( new rootActions.ChangeLoading(value));
    }

    showInfoModal(value: boolean, info: string, link: string, param: null, skin: string) {
        console.log('---->>>>.... Ejecutando Tracking Effect showInfoModal: ' + value + ' ;Param: ' + param + ' ;Info: ' + info);
        this.storeRoot.dispatch( new rootActions.ChangeInfoModal({value: value, info: info, link: link, param: param, skin: skin }));
    }
}
